import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from "moment";
import { FlatpickrOptions } from "ng2-flatpickr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import Italian from "flatpickr/dist/l10n/it";
import { TutorialService } from "app/auth/service/tutorial.service";
import { IAbsence, IAbsenceForm, IAbsenceType } from "app/auth/models/absences";

@Component({
  selector: "app-popup-permissions",
  templateUrl: "./popup-permissions.component.html",
  styleUrls: ["./popup-permissions.component.scss"],
})
export class PopupPermissionsComponent implements OnInit {
  @ViewChild("permissions") permissions;
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  public formGroup: FormGroup;
  public basicDateOptions: FlatpickrOptions;
  public absenceTypesList: IAbsenceType[] = [];
  public requireFile: boolean = false;
  public requireNote: boolean = false;
  public permissionFile: string = "";
  public notAvailableDate: string[] = [];
  public myAbsences: IAbsence[] = [];
  public fileName: string = null;
  public showErrors: boolean = false;

  constructor(
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    public _absencesService: AbsencesService,
    public _utilService: UtilsService,
    public _tutorialService: TutorialService,
  ) {}

  async ngOnInit() {
    this.formGroup = this._formBuilder.group({
      type: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      note: new FormControl(""),
      day: new FormControl(moment(), [Validators.required]),
      hour_from: new FormControl(
        {
          hour: 9,
          minute: 0,
        },
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)],
      ),
      hour_to: new FormControl(
        {
          hour: 10,
          minute: 0,
        },
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)],
      ),
      file: new FormControl(null),
    });
    await this.loadHolidaysTypes();
    await this.notAvailablesDate();
    this.basicDateOptions = {
      altFormat: "d/m/Y",
      defaultDate: "today",
      locale: Italian.it,
      altInput: true,
      utc: true,
      minDate: "today",
      disable: this.notAvailableDate,
      disableMobile: true,
    };
    this.openModal();
  }

  openModal() {
    this._modalService.open(this.permissions, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
  }

  async loadHolidaysTypes() {
    this.absenceTypesList = await this._absencesService.getTypeList();
    this.absenceTypesList = this.absenceTypesList.filter((item) => item.type === "permesso");
    const permissionDefault = this.absenceTypesList.find((item) => item.name.includes("riduzione orario"));
    if (!!permissionDefault) {
      this.formGroup.patchValue({
        type: permissionDefault.id,
      });
    }
  }

  async notAvailablesDate() {
    await this._absencesService.getMineAbsences();
    this.myAbsences = this._absencesService.myAbsences;
    this.myAbsences = this.myAbsences.filter((item) => item.status == 1);
    this.myAbsences.map((item: IAbsence) => {
      const absenceDate: moment.Moment = moment(item.from.split("T")[0]).utc();
      if (!absenceDate || !absenceDate.isValid) return;

      const from: moment.Moment = moment(item.from).utc();
      const to: moment.Moment = moment(item.to).utc();

      if (item.type.category !== "permesso") {
        // Se è un permesso quindi singolo giorno non facciamo nulla
        const difference: number = to.diff(from, "days");

        for (let i = 0; i <= difference; i++) {
          absenceDate.add(1, "days");
          this.notAvailableDate.push(absenceDate.format("YYYY-MM-DD"));
        }
      }
    });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroup.reset();
    this._utilService.toggleAbsencePopup("permissions");
  }

  checkAdditionalInput() {
    let selectedAbsence: IAbsenceType[] = null;
    if (this.formGroup.value.type) {
      let selectedTypeAbsences: number = this.formGroup.value.type;
      selectedAbsence = this.absenceTypesList.filter((item) => item.id === selectedTypeAbsences && (item.require_file === 1 || item.require_note === 1));
      if (selectedAbsence.length > 0) {
        this.requireFile = selectedAbsence[0].require_file === 1;
        this.requireNote = selectedAbsence[0].require_note === 1;
      } else {
        this.requireFile = false;
        this.requireNote = false;
      }
    }

    const selectedTypeName = this.absenceTypesList.find((item: IAbsenceType) => item.id === this.formGroup.value.type).name;

    if (selectedTypeName === "Congedo padre") {
      this.formGroup.controls.file.setValidators([Validators.required]);
      this.formGroup.controls.note.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(255)]);
    } else {
      this.formGroup.controls.file.clearValidators();
      this.formGroup.controls.note.clearValidators();
    }
    this.formGroup.controls.file.updateValueAndValidity();
    this.formGroup.controls.note.updateValueAndValidity();
  }

  setHour() {
    this.formGroup.patchValue({
      hour_to: {
        hour: this.formGroup.value.hour_from.hour + 1,
        minute: this.formGroup.value.hour_from.minute,
      },
    });
  }

  async handlerChangeFileInput(event: { target: { files: { name: string }[] } }) {
    this.fileName = event.target.files[0].name;
    await this._utilService.convertFileToBase64(event, async (e: { target: { result: string } }) => {
      return (this.permissionFile = e.target.result);
    });
  }

  async sendAbsenceRequest() {
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }
    const hourFrom: { hour: number; minute: number } = this.formGroup.value.hour_from;
    const hourTo: { hour: number; minute: number } = this.formGroup.value.hour_to;

    if (this.requireNote && this.formGroup.value.note.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_NOTE_REQUIRE" });
      return false;
    }

    if (this.requireFile && this.permissionFile.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_FILE_REQUIRE" });
      return false;
    }

    const day: moment.Moment = moment(this.formGroup.value.day[0]);

    const dayFrom: moment.Moment = day.clone();
    dayFrom.set("hour", hourFrom.hour);
    dayFrom.set("minute", hourFrom.minute);

    const dayTo: moment.Moment = day.clone();
    dayTo.set("hour", hourTo.hour);
    dayTo.set("minute", hourTo.minute);

    if (dayTo < dayFrom) {
      await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }
    //Controllo che le ore di permesso siano un multiplo di 30(Le ore di permesso possono essere richieste in multipli di 30 minuti.)
    const differenceHour: number = dayTo.diff(dayFrom, "minute") / 30;
    //Controllo che non sia un float, se il numero è un float significa che non è un multiplo di 30 e diamo errore
    if (Number(differenceHour) === differenceHour && differenceHour % 1 !== 0) {
      return this._utilService.showSWALError({ text: "ERROR_HOUR_REQUESTED" });
    }
    const data: IAbsenceForm = {
      type: this.formGroup.value.type,
      note: this.formGroup.value.note,
      from: moment(dayFrom).format("YYYY-MM-DD HH:mm:00"),
      to: moment(dayTo).format("YYYY-MM-DD HH:mm:00"),
    };
    this._utilService.showLoading();
    await this._absencesService
      .sendAbsence(data)
      .then(async (response: { file_name: string; id: number }) => {
        if (this.requireFile) {
          this._utilService.hideLoading();
          const uploadFile = await this._utilService.upload_media("documents", response.file_name, this.permissionFile);
          if (uploadFile) {
            await this._absencesService.updateAbsence(response.id, { has_file: 1 });
          }
        }
        this._utilService.hideLoading();
        this.callbackFn.emit();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_PERMISSIONS" });
        this.modalClose();
      })
      .catch((response) => {
        if (response === "absence already exist") {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_ABSCENCE_ALREADY_REQUESTED" });
        } else {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_SEND_PERMISSIONS" });
        }
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Richiesta Permessi";
    this._tutorialService.force_open_modal = true;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }
}
